import axios, { AxiosInstance, AxiosResponse } from "axios";
import config from "@/utils/cognitoUrlConfig";

interface File {
  name: string;
  link: string;
}

interface SharedFilesResponse {
  data: Array<File>;
}

class SharedFilesService {
  client: AxiosInstance;

  constructor(jwt: string) {
    this.client = axios.create({
      baseURL: config.apiURL,
      withCredentials: false,
      headers: {
        Authorization: jwt
      }
    });
  }
  async getFolders(): Promise<AxiosResponse<SharedFilesResponse>> {
    return await this.client.get("/list_folder");
  }

  async createFolders(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.post("/create_folder", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  async deleteFolder(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/delete_folder", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  async deleteFile(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.put("/delete_shared_file", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  async getFilesInFolders(formData: any): Promise<AxiosResponse<SharedFilesResponse>> {
    return await this.client.put("/list_files_in_folder", formData, {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }

  async uploadFile(formData: any): Promise<AxiosResponse<string>> {
    return await this.client.post("/upload_shared_file", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    });
  }
}

export default SharedFilesService;
